export default {
    site: {
        common: {
            hello: "Helló",
            thankYou: "Köszönöm",
            forMoreInfo: "további infóért",
            hoverOverColumnHeaders: "Több infóért tartsd az egeret az oszlop fejlécén.",
            username: "felhasználónév",
            score: "Pontszám",
            points: "Pont",
            pointsAbbreviation: "pont",
            chapter: "Fejezet",
            tier: "Bónusz",
            t1: "B1",
            t2: "B2",
            t3: "B3",
            collectionsPerDay: "Napi termelés",
            relicBoostPercent: "Ereklye bónusz %",
            mountainHallPercentShort: "H. Csarnok %", // used in table heading keep it short.
            updated: "frissítve",
            lastUpdated: "Utolsó frissítés",
            created: "created",
            role: "rang",
            Fellow: 'Testvér',
            Ambassador: 'Prefektus',
            Mage: 'Mágus',
            Archmage: 'Főmágus',
            saveChanges: "Változások mentése",
            copy: "Másolás",
            close: "Bezárás",
            cancel: "Mégse",
            action: "Action",
            date: "Dátum",
            Left: "Távozott",
            Joined: "Csatlakozott",
            human: "Ember",
            elf: "Elf",
            search: "Keresés",
            enter: "Enter",
            yes: "Igen",
            no: "Nem",
            tournament: "Bajnokság",
            tournaments: "Bajnokságok",
            fellowship: "Testvériség",
            player: "Játékos",
            member: "Tag",
            history: "Előzmények",
            tournamentHistory:  "Bajnokság előzmények",
            scoreHistory: "Pontszám előzmények",
            server: "Szerver",
            lastWeekGain: "Last Week Gain",
            comingSoon: "Hamarosan",
            chest: "láda",
            yourServer: "Szervered",
            allServers: "Összes Szerver",
            boosts: "Bónuszok",
            marble: "márvány",
            steel: "acél",
            planks: "deszka",
            crystal: "kristály",
            scrolls: "tekercs",
            silk: "selyem",
            elixir: "elixír",
            magic_dust: "varázspor",
            gems: "drágakő",
            sentient: "érző",
            goods: "áru",
            average: "átlag",
            expansions: 'Bővítések', // 5x5 grids
            cultureBoostMinimum: 'Minimum kultúra bónusz',
            cultureBoostCalculated: 'Számított kultúra bónusz',
            neighborlyHelp: 'Szomszédi segítség',
            neighborlyHelpAbbreviation: 'NH'
        },
        // HIGH PRIORITY
        nav: {
            home: "Kezdőlap",
            players: "Játékosok",
            fellowships: "Testvériségek",
            tournaments: "Bajnokságok",
            contact: "Kapcsolat",
            donate: "Adakozás",
            faq: "GYIK",
            news: "Hírek",
            privacyPolicy: "Adatvédelem",
            me: "Városom",
            myFellowship: "Testvériségem",

            // NOTE USED AT THE MOMENT
            globalStats: "Globális Statisztika",
            articles: "Cikkek",
            fellowshipAdventure: "Testvériségi kalandok",
            recruit: "Toborzás",
        },
        // VERY HIGH PRIORITY!
        elvenArchitect: {
            viewCityOnElvenArchitect: "Város megtekintése az ElvenArchitect-on"
            ,obtainingLink: "Link Generálás"
            ,successMessage: "Kész! Kattints az alsó linkre az ElvenArchitect indításához"
            ,ageOfLink: "A fenti link azt a várost mutatja, amilyen volt: "
            ,clickToGetCurrentCity: "<-- Kattints a jelenlegi városért",
        },
        // High Priority
        playerSelection: {
            headline: "Nézd az oldalt mint",
            description: "Ez frissiteni fogja különböző részeit a weboldalnak amik a játékoshoz vannak igazitva. Például: Testvériségem, Használóm, bajnokságok, és helyezések.",
            youAreViewing: `Jelenleg {username} játékosként a {serverName} szerverről látod a weboldalt.`,
            changeUser: "Játékos váltás",
            enterYourUsernameToGetStarted: "A kezdéshez add meg az Elvenar felhasználónevedet",
            thisIsNotASignup:"Ez nem feliratkozás.  A neved megadásával mi csak módositjuk részedre a weboldalt.  Sok Elvenar szerver van, de mi a Te syervered helyezéseit fogjuk mutatni.  Valamint a testvériséged és személyes felhasználó oldalak is létrejönnek."
        },
        searchBoxes: {
            enterFellowshipName: 'Ird ide a Testvériség nevét',
            instructions: "Ird be a nevet és válassz egyet.",
            noFellowship: "Nincs ilyen Testvériség",
        },
        relativeTime: {
            // Relative time strings - note: these aren't yet implemented in the code
            daysAgo: "napja",
            minsAgo: "perce",
            hoursAgo: "órája",
            justNow: "pont most",
            never: "Soha",
        },
        home: {
            welcome: "Üdvözöl az Elven Stats!",
            youAreViewing: "Jelenleg {username} játékosként a {serverName} szerverről látod a weboldalt.",
            youCanChange: "Megváltoztathatod a játékost ha rákattintassz az avatárra felső jobb vagy <router-link to='/contact'>meglátogatod ezt az oldalt</router-link>",
            features: {
                headline: "Features",
                fellowshipAdministration: {
                    headline: "Fellowship Administration <strong>MADE EASY</strong>",
                    bullet1: "Automatic tracking of boosted goods to help you better balance your fellowship",
                    bullet2: "Automatic tracking/generation of weekly report emails including points, tournament participation, monthly growth and motivating \"Accolades\" and personal best records",
                    bullet3: "Help identify your fellow members production imbalances such as supplies or incorrect ratio of tiers",
                },
                elvenArchitectIntegration: {
                    headline: "ElvenArchitect <strong>Integration</strong>",
                    description: "Load your city exactly as it is into ElvenArchitect in seconds! Use this to better plan your next big city reorganization or to find space you didn't realize you had! Look for the ElvenArchitect logo on the player pages."
                },
                advancedRankingLists: {
                    headline: "Advanced <strong>Ranking Lists</strong>",
                    bullet1: "Ranking List by Unlocked Areas (to compare yourself against people at same stage)",
                    bullet2: "View Boosts, Chapter Number, and more in Player lists.",
                },
                fellowshipTournamentTracking: {
                    headline: "Fellowship Tournament <strong>Tracking</strong>",
                    description: "See how your fellowship stacks up against others. Challenge other fellowships to a dual for a friendly competition!",
                },
                matchMaking: {
                    headline: "Match <strong>Making</strong>",
                    description: "ElvenStats tracks players boosts and the goods production ratios of fellowships.  With this information, fellowships can recruit the right candidates to balance their goods. Users looking for a fellowship can find fellowships that actually NEED their boosts. Saving time and reducing rejection!"
                }
            }
        },
        fellowship: {
            stats: {
                rank: "Helyezés",
                points: "Pontszám",
                medianUserScore: "Átlag <strong>pontszám</strong>",
                memberCount: "Tagok <strong>száma</strong>",
            },
            barCharts: {
                clickSlice: "Kattints az oszlopra a tagok termeléséért",
                tier1: "Bónusz 1",
                tier2: "Bónusz 2",
                tier3: "Bónusz 3",
                drillDown: "Vissza {0}"
            },
            idealCandidate: {
                heading: "Ideális jelentkező",
                description: "Körülbelül {medianScore} ponttal rendelkezik és a következő árukat termeli: {boosts}",
                note: "Néhány bónusz kombináció nem lehetséges. Katt {0}"
            },
            memberGoodsTable: {
                heading: "Tagok áru termelése",
                description: `Ez a táblázat azt mutatja, hogy mennyi árut termelnek a tagok a testvériségben. Alapértelmeztetten úgy számol,
                hogy mindenki naponta 3 alkalommal gyűjti be az árukat (2x9 óra és 1x3 óra). Pontosabb adatokért kérdezd meg a testvériség tagjait, hogy termelnek, és itt állítsd be.
                A beállításokat lehet menteni, így legközelebb ezt már nem kell beírni. A fenti diagramok is frissülni fognak ezzel. További infóért mutass rá az oszlopokra az egérrel.'
                `,
                refreshButtonText: 'Taglista frissítése',
                refreshButtonTip: 'Ezzel frissülnek az új tagok, eltűnnek a régiek, frissülnek a rangok és a jelenlegi pontszámok is.',
                inactiveWarningTip: 'User may be inactive, Score Last Updated: {0}',
                collectsPerDayValidation: "Csak 1-6 között lehet",
                boostPercentValidation: "Csak 40 - 700 között lehet, és nem tartalmazza a Hegyi Csarnok bónuszát",
                perDayShort: "/nap",

                // HIGH PRIORITY - IMPORTANT TOOLTIPS
                scoreTip: "A játékos pontszáma (nem valós idejű). Hetente néhány alkalommal frissül.",
                chapterTip: "A játékos ebben a fejezetben van. Például: Elementálok = 12, Félszerzetek = 11, etc.",
                boostTip: "A játékos bónuszai és a naponta megtermelt mennyiség.",
                collectsPerDayTip: `***SZERKESZTHETŐ*** <br/>Napi termelés. Ez a szám azt jelenti, hogy naponta hányszor van beszedve a termelés. 1 és 6 között lehet.  1 = 1x24 óra, 2=2x9 óra, 3=2x9 óra +     1x3 óra, 4=1x9 óra + 3x3 óra, 5=4x3 óra + 1x9 óra, 6=5x3 óra + 1x9 óra<BR/>További infóért nézd meg a GYIK-ot.`,
                relicBoostPercentTip: `***SZERKESZTHETŐ***<br/>Ereklye bónusz 40 és 700 között.  Hegyi Csarnok bónuszt nem tartalmaz.`,
                mountainHallPercentTip: "Ez a játékos Hegyi Csarnok bónusza. A normál bónusszal együtt mutatja a százalékot.",
                updatedTip: "Mutatja, hogy a játékos városa mikor volt utoljára elemezve.  Ez vonatkozik a bónuszokra, az elven architect adatokra, számolja az áruk termelését, Hegyi Csarnok bónuszt, stb. A várostérkép időközönként automatikusan frissül, de frissítheted azonnal is, ha a lenti gombra kattintasz.",

            },
            coinsAndSuppliesTable: {
                heading: "Arany és alapanyag termelés",
                description: `The key column here is "Supplies Left" as it indicates whether a member will produce enough supplies to keep their
                manufactories producing 24/7.  Use the toggle switches below to take into account the players minimum culture boost (which is the boost you'd have if you had no neighborly help)
                and/or the number of times the member collects per day (as specified in Goods Table above).  Turning both off is useful if you want to see how much of the supplies are attributed
                to more manufactories or a higher culture boost. Finally, please note that having low negative (~10% of total) number of supplies left is fairly common. There are many ways players
                supplement their supplies such as by visiting neighbors, producing supplies at faster intervals (Beverages, Simple Tools, Bread...) or using Power of Provision spells.
                Think of the negative value as what you'd need to make up on a daily basis by doing one of these options.
                NOTE: at the moment troop production is not taken into account in the supplies used (Only Tier 1, Tier 2, and Tier 3 goods) so you may need more.`,

                // These are the column text that show up under the icons. Keep them short.
                minBoostPercent: "Min Bónusz %",
                made: "Termelve",
                used: "Használva",
                left: "Maradék",

                // Low Priority TOOL TIPS
                minimumCultureBoostPercent: "The culture boost percentage.  IMPORTANT: this is calculated assuming NO NEIGHBORLY HELP to culture buildings. In reality, this will likely be higher in your cities.",
                moneyComputedTip: "The amount of coins produced in a day, includes any Ancient Wonders that produce coins",
                moneyUsedComputedTip: "The amount of coins consumed by producing goods.",
                moneyRemainingComputedTip: "Coins - Coins Used, it's the surplus or deficit in coins a player will have each day",
                suppliesComputedTip: "The number of supplies that would be produced if all workshops were set to 24x1 (Toolboxes) + any ancient wonders. (does not include set bonuses)",
                suppliesUsedComputedTip: "The number of supplies consumed by producing goods. DOES NOT include supplies used by your barracks! See explanation above.",
                suppliesRemainingComputedTip: "Supplies - Supplies Used, it's the surplus or deficit in supplies a player will have each day",
                manaTip: "The amount of Mana produced in 24 Hours (does not include Dragon Abbey)",
            },
            popCultureTable: {
                heading: "Population/Culture Details",
                description: 'The table below shows population/culture for each member. Hover over the column headers for more information.',

                // Icon Sub-Headings
                minBoostPercent: "Min Boost %",
                levels: "Levels",
                total: "Total",
                working: "Working",
                available: "Available",
                required: "Required",

                // Low Priority - Tool Tips
                wonderLevelsTip: "The total number of ancient wonder levels a player has.",
                cultureBoostPercentTip: "The culture boost percentage.  IMPORTANT: this is calculated assuming NO NEIGHBORLY HELP to culture buildings. In reality, this will likely be higher in your cities.",
                totalPopulationTip: "Total Culture produced by residences, culture/population hybrid buildings and ancient wonders",
                workingPopulationTip: "Working Population - The amount consumed by buildings",
                availablePopulationTip: "Available Population",
                totalCultureTip: "Total Culture produced by culture buildings, culture/population hybrid buildings and ancient wonders",
                requiredCultureTip: "Required Culture needed for all your buildings",
                availableCultureTip: "Available Culture",
            },
            cityCoverageTable: {
                heading: "City Coverage",
                description: "Shows how many tiles are used in each members city for the particular building type. The empty tiles are tiles which are currently not being used.",
                tiles: 'Tiles'
            },

            // HIGH PRIORITY TO TRANSLATE
            weeklyReport: {
                heading: "Heti Email Report",
                description: "Minden héten automatikusan összeállitunk egy heti összegzést, amit megoszthatsz a fellowship tagjaival. Az előző heti összegzés minden vasárnap elérhető (kb este 8 órakor UTC). Egyszerűen másold be az alul található szöveget!",
                selectReportHint: "Válaszd ki a reportot a hétre, ami ezen a napon végződik",
                reportsAreOptimizedFor: "Email reports are optimized for display in the Elvenar messaging system such that columns align as properly as possible and usernames are truncated so it'll fit in a single message.",
                accolades: "accolades",
                tourneyChamp: " - Bajnokság Champ (this week): {0}",
                tourneyHero: " - Bajnokság Hero (last 4 weeks): {0}",
                highestGrowthPlusPercentage: " - Legmagasabb növekedés és százalék (points & percentage): {0}",
                highestGrowthPoints: " - Legmagasabb növekedés (pontok): {0}",
                highestGrowthPercentage: " - Legmagasabb növekedés (százalék): {0}",
                highestGrowthError: " - Legmagasabb növekvés: Nem lehet megállapitani, több adatra van szükség",
                newPersonalRecords: "Új személyes rekord",
                userSetANewPersonalRecordFor: " * {0} új személyes rekordot döntött: {1}",
                allMembersByPointGainThisWeek: "MINDEN TAG pontok szerinti növekedése / százalék (ezen a héten)",
                tournamentPointsHeader: "BAJNOKSÁG Pontok (ezen a héten / ÖSSZES {0} ÓTA)",
                top8ByPercentage: "ELSŐ 8 százalék szerint (ezen a héten)",
                top8ByPointsSince: "ELSŐ 8 pontok szerint (Since {0})",
                top8ByPercentageSince: "ELSŐ 8 százalék szerint (Since {0})",
                reportGeneratedBy: "Reportot összeállitotta az elvenstats.com, több itt: ",
                mostPointsInAWeek: "Legtöbb pont a héten",
                highestTournamentScore: "Legmagasabb Bajnokság pontok",
                highestTournamentRank: "Legmagasabb Bajnokság helyezés",
                insufficientHistoryForThesePlayers: "* Omitted: {0} due to insufficient history.  They will be included next week",
                insufficientHistory1Week: "* Nincs elég adat ehhez a részhez. Nézz vissza egy hét múlva!",
                insufficientHistory4Weeks: "* Nincs elég adat ehhez a részhez. 4 heti adat szükséges. Nézz vissza hamarosan!",
            },
            memberHistory: {
                heading: "Tagok adatai",
                noChangesDetected: "Nem észleltünk változást a tagok adataiban mióta a fellowship követése elkezdődött {0} -an"
            },
            // Medium Priority
            notifications: {
                unsavedChanges: 'Nem mentetted le a változtatásokat. Ha befejezted az adatok változtatását, kattints az elmentés gombra.',
                standbyImporting: 'Várj: Importálunk néhány tagot akiknek az adatai hiányosak',
                limitedHistory: "Csak nem rég kezdtük követni ezt a {0} igy csak kevés adatunk van.  Minden vasárnap heti snapshots fognak megjelenni itt. Gyere vissza gyakran!",
                noChangesSinceTrackingBegan: "Nincs semmi változás mióta elkezdtük a követést",
            }
        },
        player: {
            fellowshipHistory: {
                heading: "Fellowship adatai"
            }
        },
        status: {
            realTimeUpdatesNotAvailableHeadline: "Realtime frissitések jelenleg nincsenek.",
            realTimeUpdatesNotAvailableDescription: "Ez általában akkor történik, miután az Elvenar Game Servers újra lettek inditva frissités vagy karbantartás céljából. Amikor ez történik, ElvenStats személyesen kell bekössön minden szerverre mielőtt információt tud letölteni a kérésekre.  Kérlek próbálkozz pár óra múlva.  Addig is a weboldal teljes mértékben üzemel.",
            copyToClipboardSuccessful: "A Clipboardra másolás sikeres volt!",
            copyToClipboardFailed: "Nem sikerült a másolás, jelöld ki az egész szöveget és nyomd meg a CTRL+C gombokat",
            errorOccurredImporting: "Error Occurred. Importing your users.",
            errorOccurredImportingMessage: "An error occurred trying to import your users.  Please try again.  If the error, persists please contact us.",
            errorOccurredImportingWillNotBeAvailableInReports: "Users which have not been imported will not be included in the reports.",
            finishedSyncSuccessful: "Finished, Sync was successful!",
            playerIsAnonymous: "Player has requested their information not be displayed on elvenstats.com",
            inactiveWarningTip: "This player may be inactive.  Score last changed: {0}",
            isFriendTip: "This player is a friend to ElvenStats.  They've either contributed their time or money to support the site!",
        }
    }
}


// WEBPACK FOOTER //
// ./src/lang/hu.js